import React, { useState } from "react";
import BaseModal from "../base/BaseModal";
import BaseButton from "../base/BaseButton";
import { Formik } from "formik";
import BaseInput from "../base/BaseInput";
import { validateDetails } from "../../utils/validateSchema";
import { useAppDispatch, useAppSelector } from "../../store";
import BaseSelect from "../base/CustomSelect";
import { sendInvite } from "../../store/slices/users/action";
import { toast } from "react-toastify";
import { roleTypes } from "../../data/utils";
import { Role } from "../../enums/role.enum";
import { useNavigate } from "react-router-dom";
import { Platform } from "../../enums/plaftorm.enum";

type InviteUserProps = {
  isOpen: boolean;
  setOpen: (open: boolean) => void;
};

const InviteUser: React.FC<InviteUserProps> = ({ isOpen, setOpen }) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [selectedRole, setSelectedRole] = useState<{ id: Role; name: string }>({
    id: Role.Org_User,
    name: "User",
  });
  const [errorMsg, setErrorMsg] = useState({});
  const { currentOrganisationAccount } = useAppSelector(
    (state) => state.authReducer
  );
  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const onClose = () => {
    setOpen(false);
    setIsProcessing(false);
  };

  const selectRole = (obj: { id: Role; name: string }) => {
    setSelectedRole(obj);
    setErrorMsg({ ...errorMsg, stateError: null });
  };

  const userObj = {
    firstName: "",
    lastName: "",
    email: "",
  };

  const SubmitInvite = async (values: {
    firstName: string;
    lastName: string;
    email: string;
  }) => {
    if (!selectedRole.id) {
      setErrorMsg({ ...errorMsg, genderError: "Please, select a role" });
      return;
    }

    if (values) {
      const inviteData = {
        ...values,
        role: selectedRole.id,
        generatePassword: true,
        organisationId: currentOrganisationAccount?.organisationId || "",
        createdFromPlatform: Platform.OrganisationDashboard,
      };

      setIsProcessing(true);

      const result = await dispatch(sendInvite(inviteData));

      if (result?.payload?.status == 201) {
        toast.success("Invite sent successfully");
        navigate(`/dashboard`);
        setOpen(false);
      } 
      if (result.payload?.statusCode >= 400 && result.payload?.statusCode < 500) {
        setIsProcessing(false);
        return toast.error(result.payload?.message || "An unexpected error has occured! please try again");
      }
      if (result.payload?.statusCode >= 500) {
        setIsProcessing(false);
        return toast.error("An unexpected error has occured! please try again");
      }
      setIsProcessing(false);
    }
    return null;
  };

  return (
    <BaseModal
      closeModal={onClose}
      closable={true}
      visible={isOpen}
      modalSize="medium"
    >
      <div className="text-center">
        <h2 className=" font-playfair textbrandColor text-[24px] font-medium">
          Invite a Member
        </h2>
        <h3 className=" text-[0.75rem]">
          Send an invite to the members to collaborate
        </h3>
        <div className="transition my-6 lg:w-11/12 w-full m-auto">
          {/* {errorMessage && (
                        <BaseToastMessage
                            type={'danger'}
                            alertMessage={errorMessage}
                            showIcon={false}
                            styleClass="!py-4 w-full"
                            innerClass="!w-full"
                        />
                    )} */}
          <Formik
            initialValues={userObj}
            onSubmit={SubmitInvite}
            validate={validateDetails}
          >
            {(formik) => {
              const {
                values,
                touched,
                handleChange,
                handleSubmit,
                errors,
                handleBlur,
              } = formik;
              return (
                <form onSubmit={handleSubmit}>
                  <BaseInput
                    id={"firstName"}
                    value={values.firstName}
                    label="First Name"
                    name={"firstName"}
                    type="text"
                    hasError={errors.firstName && touched.firstName}
                    change={handleChange}
                    blur={handleBlur}
                    bodyStyles="mb-6"
                    errorMsg={errors.firstName}
                  />
                  <BaseInput
                    id={"lastName"}
                    value={values.lastName}
                    label="Last Name"
                    name={"lastName"}
                    type="text"
                    hasError={errors.lastName && touched.lastName}
                    change={handleChange}
                    blur={handleBlur}
                    bodyStyles="mb-6"
                    errorMsg={errors.lastName}
                  />

                  <BaseInput
                    id={"email"}
                    value={values.email}
                    label="Email Account"
                    name={"email"}
                    type="email"
                    hasError={errors.email && touched.email}
                    change={handleChange}
                    blur={handleBlur}
                    bodyStyles="mb-8"
                    errorMsg={errors.email}
                  />

                  <div className="mb-6">
                    <BaseSelect
                      value={selectedRole}
                      onChange={selectRole}
                      options={roleTypes}
                      styleClass=""
                      label="Select Role"
                      name="selectRole"
                      selectKey="name"
                    />
                  </div>

                  <BaseButton
                    text="Send Invite"
                    type="submit"
                    variant="neutral"
                    styles=" w-3/5 mx-auto mt-4"
                    processing={isProcessing}
                  />
                </form>
              );
            }}
          </Formik>
        </div>
      </div>
    </BaseModal>
  );
};

export default InviteUser;
